import React, { FC } from 'react';
import { Formik } from 'formik';
import { Form } from 'formik-antd';
import { object } from 'yup';
import { FormikOnSubmit } from 'lib/formik.utils';
import {
  requiredEmailValidationSchema,
  firstNameValidationSchema,
  lastNameValidationSchema,
} from 'common/config/validationSchema';
import { defaultFormLayout } from 'common/config/formLayout';
import { SaveButton } from 'common/components/SaveButton';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerProfileOwnerFormItems } from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement/BusinessPartnerRegisterProfileOwnerPage/BusinessPartnerRegisterProfileOwnerFormItems';

export type BusinessPartnerRegisterProfileOwner = {
  partner: any;
  firstName: string;
  lastName: string;
  email: string;
};

const initialValues: BusinessPartnerRegisterProfileOwner = {
  partner: '',
  firstName: '',
  lastName: '',
  email: '',
};

export interface BusinessPartnerRegisterProfileOwnerFormProps {
  onSubmit: FormikOnSubmit<BusinessPartnerRegisterProfileOwner>;
  loading?: boolean;
}

export const BusinessPartnerRegisterProfileOwnerForm: FC<BusinessPartnerRegisterProfileOwnerFormProps> = ({
  onSubmit,
  loading = false,
}) => {
  const intlMessage = useFormatMessage();

  const validationSchema = object().shape({
    firstName: firstNameValidationSchema(intlMessage),
    lastName: lastNameValidationSchema(intlMessage),
    email: requiredEmailValidationSchema(intlMessage),
    partner: object().nullable(),
  });

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <Form {...defaultFormLayout}>
        <BusinessPartnerProfileOwnerFormItems />
        <SaveButton id="button-save-register-user" loading={loading} />
      </Form>
    </Formik>
  );
};
